import { isString } from "lodash";
import { reIsDeepProp, reIsNumProp } from "../hooks/useOverrides";
var Override = function Override(_ref) {
  var slot = _ref.slot;
  if (!isString(slot) || reIsDeepProp.test(slot) || reIsNumProp.test(slot)) {
    throw new Error("\"".concat(slot, "\" isn't allowed as an override key"));
  }
  return null;
};
export default Override;